namespace advisorop.components.advisor {

    export class InvestorListController {

        public investors: any[];
        public dgInvestorSettings; 
        public onInvestorChanged: (any) => any;       
        public onInvestorsLoading: (any) => any;       
        public user: domains.identity.IUser;

        constructor(private advisorService: services.AdvisorService,
            private generalService: services.GeneralService,
            private ids: services.IdentityService) {

            this.dgInvestorSettings = {
                export: {
                    enabled: true,
                    fileName: `Investors`
                },
                bindingOptions: {
                    dataSource: `vm.investors`
                },
                scrolling: {
                    mode: `standard`,
                    useNative: true
                },
                //height: `350px`,
                paging: { pageSize: 20 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,
                stateStoring: {
                    enabled: true,
                    type: `localStorage`,
                    storageKey: `dgInvestorSettings`
                },
                columnChooser: {
                    enabled: true,
                    title: `Select columns`
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                noDataText: `Investor Not Found`,
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: 'Search...'
                },                
                columns: [
                    { dataField: 'fullName', caption: 'Name', width: 120, cellTemplate: 'colFullName' },
                    { dataField: 'investorTypeDescription', caption: 'Type' },
                    { dataField: 'tinForPublic', caption: 'TIN/SSN', width: 140, visible: false },
                    { dataField: 'fullAddress', caption: 'Address' },
                    { dataField: 'statusDescription', caption: 'Status', width: 60 },
                    { dataField: 'contactFullName', caption: 'Contact', visible: true },
                    { dataField: 'contactPhone', caption: 'Phone Number', visible: true },
                    { dataField: 'contactEmail', caption: 'E-mail', visible: true },
                    { dataField: 'systemLogin.username', caption: 'Username', visible: true, width:90 },                    
                    { dataField: 'systemLogin.loginStatusDesc', caption: 'Login stat.', visible: true, width: 70 },
                    { dataField: 'systemLogin.twoFactorEnabled', caption: '2FA', visible: true, width: 55, dataType: 'boolean' },
                    {
                        caption: 'Last Login', visible: true, dataType: 'date', format: 'MM/dd/yy hh:mm a', width: 105,
                        allowSorting: true, allowFiltering: true,
                        calculateCellValue: function (investor) {
                            if (!investor.systemLogin) {
                                return ``;
                            }
                            if (!investor.systemLogin.lastLogin) {
                                return ``;
                            }
                            return new Date(generalService.toUTCDateString(investor.systemLogin.lastLogin));
                        }
                    },
                    { dataField: 'leadAnalystsStr', caption: 'Lead Analyst(s)', visible: true, width: 105 },
                    { dataField: 'systemLogin.loginStatusDesc', caption: '#', cellTemplate: 'btnActions' }
                    
                ],
                selection: {
                    mode: 'single',
                    showCheckBoxesMode: 'onClick'
                },
                onSelectionChanged: function (selectedItems) {
                    var data = selectedItems.selectedRowsData[0];
                    if (data) {
                        this.vm.onInvestorChanged({ id: data.id });
                    }
                }
            };
        }
        
        impersonateInvestor(investor: domains.IAdvisor): void {
            if (window.confirm(`Impersonate ${investor.fullName} ?`)) {
                // authenticate servicer as advisor 
                this.ids.impersonateUser(investor.systemLogin.username)
                    .then(response => {

                        // clear localstorage
                        localStorage.clear();

                        // redirect page to invesotr dashboard
                        window.location.href = `/investor`;
                    }, err => this.generalService.showError(err))
            }
        }

        //enableSL(investor: domains.IInvestor)
        enableSL(investor: any): void {
            investor.aladda = true;

            this.advisorService.enableInvestorSL(investor)
                .then(response => {
                    //investor.systemLogin.loginStatus = 4;
                    //investor.systemLogin.loginStatusDesc = `SETUP`;
                    investor.systemLogin = (<domains.IInvestor>response.data).systemLogin;
                    toastr.success(`Activation email sent to client at ` + (<domains.IInvestor>response).contactEmail + `.`);
                }, err => this.generalService.showError(err))
                .finally(() => { investor.aladda = false; });
        };

        reactivateSL(investor: any): void {
            investor.rladda = true;

            this.advisorService.reactivateInvestorSL(investor)
                .then(response => {
                    //investor.systemLogin.loginStatus = 4;
                    //investor.systemLogin.loginStatusDesc = `SETUP`;
                    investor.systemLogin = (<domains.IInvestor>response.data).systemLogin;
                    toastr.success(`Reactivation email sent to client at ` + (<domains.IInvestor>response.data).contactEmail + `.`);
                }, err => this.generalService.showError(err))
                .finally(() => { investor.rladda = false; });
        };

        reactivateLinkSL(investor: any): void {
            investor.rlladda = true;

            this.advisorService.reactivateLinkInvestorSL(investor)
                .then(response => {
                    var resp = <domains.IInvestorAndLink>response.data;
                    investor.systemLogin = (<domains.IInvestor>resp.investor).systemLogin;
                    var linkinfo = `User Email: ` + investor.systemLogin.email + `\r\n\r\nActivation Link: ` + resp.link
                    navigator.clipboard.writeText(linkinfo);
                    console.log(`Linkinfo is: \r\n` + linkinfo);
                    toastr.success(`The following activation information has been copied to your clipboard: \r\n` + linkinfo);
                }, err => this.generalService.showError(err))
                .finally(() => { investor.rlladda = false; });
        };

        passwordLinkSL(investor: any): void {
            investor.plladda = true;

            this.advisorService.passwordLinkInvestorSL(investor)
                .then(response => {
                    var link = response.data;
                    toastr.success(`Link is: ` + link);
                }, err => this.generalService.showError(err))
                .finally(() => { investor.plladda = false; });
        };

        disableSL(investor: any): void {
            investor.dladda = true;

            this.advisorService.disableInvestorSL(investor)
                .success((data) => {
                    //investor.systemLogin.loginStatus = 3;
                    //investor.systemLogin.loginStatusDesc = `CANCELED`;
                    investor.systemLogin = (<domains.IInvestor>data).systemLogin;
                    toastr.success(`User system login canceled.`);
                })
                .error((data, status) => {
                    toastr.error(`Error ` + status + ` ` + data);
                }).finally(() => { investor.dladda = false; });            
        };

        lockSL(investor: any): void {
            investor.lladda = true;

            this.advisorService.lockInvestorSL(investor)
                .success((data) => {
                    //investor.systemLogin.loginStatus = 2;
                    //investor.systemLogin.loginStatusDesc = `LOCKED`;
                    investor.systemLogin = (<domains.IInvestor>data).systemLogin;
                    toastr.success(`User system login locked.`);
                })
                .error((data, status) => {
                    toastr.error(`Error ` + status + ` ` + data);
                }).finally(() => { investor.lladda = false; });            
        };

        unlockSL(investor: any): void {
            investor.uladda = true;

            this.advisorService.unlockInvestorSL(investor)
                .success((data) => {
                    investor.systemLogin.loginStatus = 1;
                    investor.systemLogin.loginStatusDesc = `ACTIVE`;
                    toastr.success(`User system login unlocked.`);
                })
                .error((data, status) => {
                    toastr.error(`Error ` + status + ` ` + data);
                }).finally(() => { investor.uladda = false; });            
        }

        loadInvestors(): void {
            this.onInvestorsLoading({ loading: true });
            this.advisorService.getInvestorsLight().success((data) => {
                this.investors = data;
            }).error((data, status) => {
                toastr.error(`Investors cannot be loaded. ERROR ` + status + `:` + data);
            }).finally(() => this.onInvestorsLoading({ loading: false }));
        };
        
        // Only an administrator may switch two-factor authentication off; the server enforces
        // this in IdentityService.SetTwoFactorEnabled, this only keeps the action out of the UI.
        isAdmin(): boolean {
            return (this.user && this.user.role == domains.AdvisoryRoles.ADVISORY_ADMIN.toString());
        }

        setTwoFactor(investor: any, enabled: boolean): void {
            // Off is always for a stated number of days; the enforcement job switches it back on
            // when they run out, so the administrator is told the date rather than left to
            // remember. See advisorop.identity.TwoFactorExemption for the wording and the range.
            let days: number = null;
            if (!enabled) {
                days = advisorop.identity.TwoFactorExemption.promptForDays(investor.fullName);
                if (days === null)
                    return;
            }

            investor.tfladda = true;

            this.advisorService.setTwoFactorInvestorSL(investor, enabled, days)
                .success((data) => {
                    investor.systemLogin = (<domains.IInvestor>data).systemLogin;
                    toastr.success(enabled
                        ? "Two-factor authentication turned on."
                        : advisorop.identity.TwoFactorExemption.offMessage(investor.fullName, days));
                })
                .error((data, status) => {
                    toastr.error(`Error ` + status + ` ` + data);
                }).finally(() => { investor.tfladda = false; });
        }

        $onInit(): void {
            this.ids.getUserPromise().then(response => {
                this.user = response;
            });
            this.loadInvestors();
        }
        
    }
    
    class InvestorList implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                //investors: `<`,
                onInvestorChanged: `&`,
                onInvestorsLoading: `&`
            };
            this.controller = [`advisorService`, `generalService`, `identityService`, InvestorListController];
            this.controllerAs = `vm`;
            this.templateUrl = `spa/advisor-module/components/investor-list.html`;
        }
    }
    angular.module(Constants.APP).component(`investorList`, new InvestorList());

}